import { TFunction } from "i18next";
import * as Yup from "yup";

export const topicImportFromCsvSchema = (t: TFunction) =>
    Yup.object().shape({
        description: Yup.string()
            .trim()
            .required(t("common:form.requiredFieldForm")),
        file: Yup.mixed<File>()
            .required(t("common:form.requiredFieldForm")),
    });

